<!-- Datos de contacto del beneficiario (cuando el trámite es para un familiar) -->
<div class="ds-card" *ngIf="(seccion === 'ambas' || seccion === 'contacto') && mostrarContactoBeneficiario">
    <div class="ds-section__head">
        <span class="material-icons">contact_phone</span>
        Datos de contacto — Beneficiario
    </div>
    <div class="ds-section__body">
        <div class="ds-summary ds-summary--grid">
            <div class="ds-summary__row">
                <span class="ds-summary__key">Nombre</span>
                <span class="ds-summary__value">{{ beneficiarioUser?.fullName }}</span>
            </div>
            <div class="ds-summary__row">
                <span class="ds-summary__key">DNI</span>
                <span class="ds-summary__value">{{ beneficiarioUser?.identificacion || 'No informado' }}</span>
            </div>
            <div class="ds-summary__row">
                <span class="ds-summary__key">Parentesco</span>
                <span class="ds-summary__value">{{ beneficiario?.parentesco || 'TITULAR' }}</span>
            </div>
            <div class="ds-summary__row">
                <span class="ds-summary__key">Email</span>
                <span class="ds-summary__value">{{ beneficiarioUser?.email || 'No informado' }}</span>
            </div>
            <div class="ds-summary__row">
                <span class="ds-summary__key">Teléfono</span>
                <span class="ds-summary__value">{{ beneficiarioTelefono || 'No informado' }}</span>
            </div>
            <div class="ds-summary__row">
                <span class="ds-summary__key">Celular</span>
                <span class="ds-summary__value">{{ beneficiarioCelular }}</span>
            </div>
            <div class="ds-summary__row">
                <span class="ds-summary__key">Fecha de nacimiento</span>
                <span class="ds-summary__value">{{ beneficiarioFechaNacimiento || 'No informada' }}</span>
            </div>
            <div class="ds-summary__row">
                <span class="ds-summary__key">Edad</span>
                <span class="ds-summary__value">{{ beneficiarioEdad }} años</span>
            </div>
        </div>
    </div>
</div>

<div class="ds-card" *ngIf="seccion === 'ambas' || seccion === 'contacto'">
    <div class="ds-section__head">
        <span class="material-icons">contact_phone</span>
        {{ tituloContactoTitular }}
    </div>
    <div class="ds-section__body">
        <div class="ds-summary ds-summary--grid">
            <div class="ds-summary__row">
                <span class="ds-summary__key">DNI</span>
                <span class="ds-summary__value">{{ usuario?.identificacion || 'No informado' }}</span>
            </div>
            <div class="ds-summary__row">
                <span class="ds-summary__key">Email</span>
                <span class="ds-summary__value">{{ usuario?.email }}</span>
            </div>
            <div class="ds-summary__row">
                <span class="ds-summary__key">Teléfono</span>
                <span class="ds-summary__value">{{ telefonoContacto }}</span>
            </div>
            <div class="ds-summary__row">
                <span class="ds-summary__key">Celular</span>
                <span class="ds-summary__value">{{ celularContacto }}</span>
            </div>
            <div class="ds-summary__row">
                <span class="ds-summary__key">Fecha de nacimiento</span>
                <span class="ds-summary__value">{{ fechaNacimientoFormateada || 'No informada' }}</span>
            </div>
            <div class="ds-summary__row">
                <span class="ds-summary__key">Edad</span>
                <span class="ds-summary__value">{{ edad }} años</span>
            </div>
        </div>
    </div>
</div>

<div class="ds-card" *ngIf="seccion === 'ambas' || seccion === 'detalles'">
    <div class="ds-section__head">
        <span class="material-icons">assignment</span>
        Detalles de la solicitud
    </div>
    <div class="ds-section__body">
        <div class="ds-summary ds-summary--grid">
            <div class="ds-summary__row">
                <span class="ds-summary__key">Trámite</span>
                <span class="ds-summary__value">{{ solicitud?.actividad?.nombre }}</span>
            </div>
            <div class="ds-summary__row">
                <span class="ds-summary__key">Nro solicitud</span>
                <span class="ds-summary__value">{{ solicitud?._nro }}</span>
            </div>
            <div class="ds-summary__row">
                <span class="ds-summary__key">Fecha solicitud</span>
                <span class="ds-summary__value">{{ solicitud?.createdAt | date: 'dd/MM/yy' }}</span>
            </div>
            <div class="ds-summary__row">
                <span class="ds-summary__key">País</span>
                <span class="ds-summary__value">{{ nombrePais }}</span>
            </div>
            <div class="ds-summary__row">
                <span class="ds-summary__key">Documentación</span>
                <span class="ds-summary__value">{{ estadoDocumentacion }}</span>
            </div>
            <div class="ds-summary__row" *ngIf="cobertura">
                <span class="ds-summary__key">Cobertura</span>
                <span class="ds-summary__value">{{ cobertura }}</span>
            </div>
            <div class="ds-summary__row">
                <span class="ds-summary__key">Titular</span>
                <span class="ds-summary__value">{{ solicitud?.usuario?.fullName }}</span>
            </div>
            <div class="ds-summary__row">
                <span class="ds-summary__key">Beneficiario</span>
                <span class="ds-summary__value">
                    {{ beneficiario?.adicional?.fullName || solicitud?.usuario?.fullName }}
                </span>
            </div>
            <div class="ds-summary__row">
                <span class="ds-summary__key">Parentesco</span>
                <span class="ds-summary__value">{{ beneficiario?.parentesco || 'TITULAR' }}</span>
            </div>
            <div class="ds-summary__row">
                <span class="ds-summary__key">Progreso</span>
                <span class="ds-summary__value">{{ solicitud?.lastState?.numberState | estadosPipe }}</span>
            </div>
        </div>
    </div>
</div>
